<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    scrollable
  >
    <v-card>
      <v-toolbar
        flat
        dark
        color="primary"
      >
        {{ question.default_translation.title }}
        <v-spacer />
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-breadcrumbs :items="breadcrumbs" />

        <question-translations-list
          v-if="question.translations.length > 0"
          :translations="question.translations"
          :faq-id="faq.id"
          :question-id="question.id"
          :all-languages="faq.all_languages"
          :missing-translations="missingTranslations"
        />

        <p
          v-else
          class="mb-0 body-2"
        >
          No translations created
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QuestionTranslationsList from '@/components/faq/QuestionTranslationsList';

export default {
  components: {
     QuestionTranslationsList
  },

  props: {
    faq: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    missingTranslations: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      search: '',
      dialog: true,
    }
  },

  computed: {
    breadcrumbs() {
      const items = [
        { text: this.$t('Questions') },
        { text: this.question.default_translation.title },
        { text: this.$t('Translations') }
      ];

      return items;
    }
  },

  watch: {
    dialog: function(value) {
      if (value === false) {
        const backUrl = this.route('faq.translate', this.faq.id);
        this.$inertia.visit(backUrl, { preserveState: true, preserveScroll: true });
      }
    }
  },

  methods: {
    create() {
      const url = this.route('faq.question-translation.create', {
        faq: this.faq.id,
        question: this.question.id,
      });

      this.$inertia.visit(url, { preserveState: true, preserveScroll: true });
    }
  }
}
</script>
